import { RegvarModel } from './index';
// TODO: Fixa questionkomponenterna så att felaktiga värden inte sparas ner till datastate. Då kan |string tas bort.
export class RegvarIntegerModel extends RegvarModel {
    setValue(value, options) {
        let val = value;
        if (typeof value === 'string') {
            const num = parseInt(value, 10);
            if (!isNaN(num)) {
                val = num;
            }
        }
        return super.setValue(val, options);
    }
}
